<template>
    <section class="panel">
            <header class="panel-heading">
                <h2 class="panel-title">Facturas Recientes</h2>
                
            </header>
            <div class="panel-body" v-if="isLoading">
                <img src="/assets/images/loading.gif" alt="loading..." />
            </div>
            <div class="panel-body" v-if="!isLoading">
                <div v-for="invoice in invoices" :key="invoice.id" >
                    <h3>Factura No. {{ invoice.invoiceNumber }} <span class="badge">{{ invoice.status }}</span></h3>
                    <p class="lead mt-xs"><b>Fecha:</b> {{ formatInvoiceDate(invoice.invoiceDate) }}, <b>Total:</b> {{ invoice.totalAmount }}</p>
                    <div>
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadPdfLink(invoice.id, invoice.invoicePdfPath)" >
                            <i class="fa fa-download"></i> Descargar PDF
                        </a>
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadXmlLink(invoice.id, invoice.invoiceXmlPath)" >
                            <i class="fa fa-download"></i> Descargar XML
                        </a>
                    </div>
                    <p class="lead mt-xl mb-xs">Complementos de Pago</p>
                    <div v-if="invoice.paymentPdfPath==null&&invoice.paymentXmlPath==null">
                        <p class="text-danger">Factura pendiente de pago.</p>
                    </div>
                    <div v-else>
                        <p class="lead mt-xs"><b>Fecha:</b> {{ formatInvoiceDate(invoice.paymentDate) }}</p>
                        <a class="mb-xs mt-xs mr-xs btn btn-primary" @click="downloadPaymentPdfLink(invoice.id, invoice.paymentPdfPath)" v-show="invoice.paymentPdfPath!='/'">
                            <i class="fa fa-download"></i> Descargar PDF
                        </a>
                        <a class="mb-xs mt-xs mr-xs btn btn-primary"@click="downloadPaymentXmlLink(invoice.id, invoice.paymentXmlPath)" v-show="invoice.paymentXmlPath!='/'" >
                            <i class="fa fa-download"></i> Descargar XML
                        </a>
                    </div>
                    <hr />
                </div>
            </div>
     </section>        
</template>

<script>
    export default {
        name: 'Invoices',
        data: function () {
            return {
                isLoading : true,
                invoices : {}
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        computed: {
            accountId () {
                return this.$store.state.accountId
            }
        },
        methods: {
            async downloadFileCore(fileType, invoiceId, filePath) {                                        
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;
                var link = `${process.env.VUE_APP_API_PATH}invoices/${invoiceId}/download/${fileType}/?filePath=${filePath}&a=${jwtAccessToken}&i=${jwtIdToken}`;
                window.open(link, '_blank');
            },
            async downloadPdfLink(invoiceId, filePath) {
                await this.downloadFileCore("invoice-pdf", invoiceId, filePath);                
            },
            async downloadXmlLink(invoiceId, filePath) {
                await this.downloadFileCore("invoice-xml", invoiceId, filePath);
            },
            async downloadPaymentPdfLink(invoiceId, filePath) {
                await this.downloadFileCore("payment-pdf", invoiceId, filePath);
            },
            async downloadPaymentXmlLink(invoiceId, filePath) {
                await this.downloadFileCore("payment-xml", invoiceId, filePath);
            },            
            formatInvoiceDate: function (dateString) {
                if (dateString == null) {
                    return "pendiente";
                }
                var date = new Date(dateString);
                // https://www.npmjs.com/package/dateformat
                var dateFormat = require('dateformat');
                return dateFormat(date, "mmmm dS, yyyy");
            },
            async refresh () {
                var self = this;
                this.isLoading = true;
                const jwtAccessToken = await this.$auth.getTokenSilently();
                const jwtIdToken = (await this.$auth.getIdTokenClaims()).__raw;

                this.axios.get(process.env.VUE_APP_API_PATH + "invoices/list",
                        {
                            headers: {
                                Authorization: `Bearer ${jwtAccessToken}`,  // send the access token through the 'Authorization' header,
                                IdToken: `${jwtIdToken}`
                            }
                        }
                    ).
                    then(function (response) {
                        //console.debug(response.data);
                        self.invoices = response.data;
                        self.isLoading = false;
                    }, function (error) {
                        self.isLoading = false;
                    });
            }
        }
    }
</script>